import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "Basket",
    component: () => (__SERVER__ ? require("./basket-view") : import("./basket-view"))
});

export default definition;
